const s = {
  name: "Display",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M4,4h7v2H6v5H4V4z"/>
		<path class="st0" d="M6,29v5h5v2H4v-7H6z"/>
		<path class="st0" d="M34,34v-5h2v7h-7v-2H34z"/>
		<path class="st0" d="M29,6h5v5h2V4h-7V6z"/>
		<path class="st0" d="M0,3c0-1.7,1.3-3,3-3h34c1.7,0,3,1.3,3,3v34c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3z M3,2C2.4,2,2,2.4,2,3v34
			c0,0.6,0.4,1,1,1h34c0.6,0,1-0.4,1-1V3c0-0.6-0.4-1-1-1H3z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Display
};
